angular
    .module("FmgProduceSuite-Launcher", [
        "ngMaterial",
        "ngMessages",
        "ui.router",
        "angular-google-analytics",
        "ngAnimate",
        "angular-locker",
        "common-services"
    ])
    .config(function(AnalyticsProvider, GoogleAnalyticsConfig) {
        if (GoogleAnalyticsConfig.Account != "NOT-USED") {
            AnalyticsProvider.setAccount(GoogleAnalyticsConfig.Account)
                .trackPages(true)
                .trackUrlParams(true);
        }
    })
    .run([
        "Analytics",
        "$transitions",
        "$location",
        function(Analytics, $transitions, $location) {
            $transitions.onSuccess({}, function(transition) {
                Analytics.trackPage($location.path());
            });
        }
    ])
    .constant("appProduct", {
        name: "launcher"
    })
    .run(function(Analytics) {})
    .config([
        "$mdIconProvider",
        function($mdIconProvider) {
            //https://github.com/nkoterba/material-design-iconsets
            $mdIconProvider
                .iconSet("action", "../assets/icon-sets/action-icons.svg", 24)
                .iconSet("alert", "../assets/icon-sets/alert-icons.svg", 24)
                .iconSet("av", "../assets/icon-sets/av-icons.svg", 24)
                .iconSet("communication", "../assets/icon-sets/communication-icons.svg", 24)
                .iconSet("content", "../assets/icon-sets/content-icons.svg", 24)
                .iconSet("device", "../assets/icon-sets/device-icons.svg", 24)
                .iconSet("editor", "../assets/icon-sets/editor-icons.svg", 24)
                .iconSet("file", "../assets/icon-sets/file-icons.svg", 24)
                .iconSet("hardware", "../assets/icon-sets/hardware-icons.svg", 24)
                .iconSet("icons", "../assets/icon-sets/icons-icons.svg", 24)
                .iconSet("image", "../assets/icon-sets/image-icons.svg", 24)
                .iconSet("maps", "../assets/icon-sets/maps-icons.svg", 24)
                .iconSet("navigation", "../assets/icon-sets/navigation-icons.svg", 24)
                .iconSet("notification", "../assets/icon-sets/notification-icons.svg", 24)
                .iconSet("social", "../assets/icon-sets/social-icons.svg", 24)
                .iconSet("toggle", "../assets/icon-sets/toggle-icons.svg", 24);
        }
    ])
    .constant(
        "app_brand",
        (function() {
            //Used to Set Branding Variables
            //primaryPalette: 'indigo',
            return {
                materialPalette: {
                    theme: "default",
                    primaryPalette: "indigo",
                    accentPalette: "green",
                    warnPalette: "red",
                    backgroundPalette: "grey"
                }
            };
        })()
    )
    .config(function($stateProvider) {})
    .config([
        "lockerProvider",
        function config(lockerProvider) {
            lockerProvider.defaults({
                driver: "session",
                namespace: "fmg",
                separator: ".",
                eventsEnabled: false,
                extend: {}
            });
        }
    ])
    .config(function($mdThemingProvider, app_brand) {
        $mdThemingProvider
            .theme(app_brand.materialPalette.theme)
            .primaryPalette(app_brand.materialPalette.primaryPalette)
            .accentPalette(app_brand.materialPalette.accentPalette)
            .warnPalette(app_brand.materialPalette.warnPalette)
            .backgroundPalette(app_brand.materialPalette.backgroundPalette);
    });
